
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

// Create a client with optimized settings for performance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (previously cacheTime)
    },
  },
})

// Priority rendering for better LCP
const startApp = () => {
  // Create root before any async operations
  const root = createRoot(document.getElementById("root")!)
  
  // Immediate rendering - no delay
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  );

  // After initial render, preload other assets
  setTimeout(() => {
    const links = ['FeaturedPlans.tsx', 'PlanCard.tsx', 'ComparisonTable.tsx']
    links.forEach(file => {
      const link = document.createElement('link')
      link.rel = 'prefetch'
      link.href = `/src/components/${file}`
      link.as = 'script'
      document.head.appendChild(link)
    })
  }, 1000)
}

// Execute immediately without delay
startApp();
